
      (function () {
        // console.log('EU withdrawal script loaded');
        const euCountries = [
          'DE',
          'FR',
          'IT',
          'ES',
          'NL',
          'BE',
          'AT',
          'PL',
          'SE',
          'DK',
          'FI',
          'IE',
          'PT',
          'CZ',
          'HU',
          'RO',
          'BG',
          'HR',
          'SK',
          'SI',
          'EE',
          'LV',
          'LT',
          'LU',
          'MT',
          'CY',
          'GR',
        ];

        const country = Shopify?.country;

        function checkButton() {
          const btn = document.querySelector('.bew-btn');

          if (btn && !euCountries.includes(country)) {
            btn.style.display = 'none';
            // console.log('EU withdrawal button hidden for:', country);
            return true;
          }

          return false;
        }

        // Initial check
        if (checkButton()) return;

        // Watch for dynamically added elements
        const observer = new MutationObserver(() => {
          if (checkButton()) {
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      })();
  